import styled from '@emotion/styled'

import { breakpoints, palette, spacing, Text } from 'main/ui'

export const FilterFormContainer = styled.div`
  background-color: ${palette.white};
  padding: ${spacing.majorScale(2)}px;
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoints.lg}px) {
    border-radius: 3px;
    width: 400px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.25);
  }
`

export const FieldCopyContainer = styled.div`
  margin-bottom: ${spacing.majorScale(2)}px;
`

export const FilterFormSubmitContainer = styled.div`
  align-self: flex-end;
`

export const CheckboxGroupContainer = styled.div`
  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }
`

export const FieldsContainer = styled.div`
  margin: ${spacing.majorScale(2)}px 0;
`

export const Clear = styled(Text)`
  margin-right: ${spacing.majorScale(4)}px;
  color: ${palette.slate};
  cursor: pointer;
`

export const Apply = styled(Text)`
  color: ${palette.skyBlue2};
  cursor: pointer;
`
